import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BrowserRouter as Router, Link } from "react-router-dom";
// Style
import { withStyles } from "@material-ui/core/styles";
import subscriptionCommon from "../Subscription/common";

// Component styles
import _ from "lodash";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import Typography from "@material-ui/core/Typography";

import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";

import PropTypes from "prop-types";
import { getExternalChatbotStatus, getTenantInteractionCounters } from "../../../../redux/actions/subscriptionActions";

class CountersInfo extends React.Component {
  state = {};

  buyLicense = license => {
    return "/manage-subscriptions?plan=" + license;
  };

  refreshState = () => {
    // Reload license info
    console.log("REFRESH STATE");
    return true;
  };

  getLicenseInfo = () => {
    if (!this.state.resourcesSum || !this.state.licenses) {
      return (
        <div>
          <br />
        </div>
      );
    }

    // Take counters and show them
    if (!this.state.licenses)
      return (
        <div>
          <br />
        </div>
      );

    const userLicenses = this.state.licenses.users;
    const licensesArr = [];
    _.map(userLicenses, (data, key) => {
      const resourcesSum = this.state.resourcesSum.users[key] ? this.state.resourcesSum.users[key].counterSum : 0;
      if (key !== "starter")
        licensesArr.push({
          plan_code: key,
          limit: data.limitSum,
          available: data.limitSum > resourcesSum ? data.limitSum - resourcesSum : 0,
          used: resourcesSum
        });
    });

    // default chatbot plan is last one
    let chatbotPlan = "pro";
    if (licensesArr.length > 0) chatbotPlan = licensesArr[licensesArr.length - 1].plan_code;

    let licenseInfo = _.map(licensesArr, x => {
      let iconColor = { color: "#000" };
      if (x.limit === x.used) iconColor = { color: "orange" };
      if (x.limit < x.used) iconColor = { color: "red" };

      return (
        <Typography style={{ display: "inline-block", justifyContent: "center", alignItems: "center" }}>
          <label>
            {x.limit.toLocaleString() +
              " " +
              x.plan_code.charAt(0).toUpperCase() +
              x.plan_code.slice(1) +
              " Licenses - " +
              x.used.toLocaleString() +
              " Used, " +
              x.available.toLocaleString() +
              " Available"}
          </label>
          &nbsp;
          <Link onClick={this.refreshState} to={this.buyLicense(x.plan_code)}>
            <IconButton style={{ ...iconColor }}>
              <AddShoppingCartIcon />
            </IconButton>
          </Link>
        </Typography>
      );
    }).reduce(
      (acc, x) =>
        acc === null ? (
          x
        ) : (
          <>
            {acc} | &nbsp; {x}
          </>
        ),
      null
    );

    let chatStatus = "";
    if (this.state.chatbotStatus && licensesArr.length > 0) {
      console.log("chatbotPlan", chatbotPlan);
      let chatStatusIcon = "";
      let iconColor = { color: "#000" };
      const status = this.state.chatbotStatus;
      if (!status.chatbotLicense && !status.userLicenses && !status.hasChatbot) {
        chatStatusIcon = "No External Chatbot License";
        iconColor = { color: "gray" };
      }
      if (!status.chatbotLicense && !status.userLicenses && status.hasChatbot) {
        chatStatusIcon = "No External Chatbot License";
        iconColor = { color: "gray" };
      }
      if (!status.chatbotLicense && status.userLicenses && !status.hasChatbot) {
        chatStatusIcon = "External Chatbot License - not used";
        iconColor = { color: "gray" };
      }
      if (!status.chatbotLicense && status.userLicenses && status.hasChatbot) {
        chatStatusIcon = "External Chatbot License - not used";
        iconColor = { color: "orange" };
      }
      if (status.chatbotLicense && !status.userLicenses && !status.hasChatbot) {
        chatStatusIcon = "External Chatbot License - User Licenses Required";
        iconColor = { color: "orange" };
      }
      if (status.chatbotLicense && !status.userLicenses && status.hasChatbot) {
        chatStatusIcon = "External Chatbot License - User Licenses Required";
        iconColor = { color: "red" };
      }
      if (status.chatbotLicense && status.userLicenses && !status.hasChatbot) {
        chatStatusIcon = "External Chatbot License - Not Configured";
        iconColor = { color: "orange" };
      }
      if (status.chatbotLicense && status.userLicenses && status.hasChatbot) {
        chatStatusIcon = "External Chatbot License is Active";
        iconColor = { color: "#000000" };
      }

      // for now, show status only if there is intention or possibility to use chatbot
      if (status.chatbotLicense || status.userLicenses) {
        chatStatus = (
          <Typography style={{ display: "inline-block", justifyContent: "center", alignItems: "center" }}>
            <label>| &nbsp; {chatStatusIcon}</label>
            <Link to={this.buyLicense(chatbotPlan)}>
              <IconButton style={{ ...iconColor }}>
                <RecordVoiceOverIcon />
              </IconButton>
            </Link>
          </Typography>
        );
      }
    }

    let interactionsStatus = "";
    if (this.state.chatbotStatus && licensesArr.length > 0 && this.state.interactionCounters) {
      const status = this.state.chatbotStatus;
      const counters = this.state.interactionCounters;
      const percent = ((total, used) => (used * 100) / total)(counters.total, counters.used);
      const linearColor = percent < 90 ? "primary" : "secondary";
      if (status.chatbotLicense || status.userLicenses) {
        let counterStatusText =
          counters.total.toLocaleString() + " Interactions - " + counters.used.toLocaleString() + " Used";
        if (counters.overflow > 0) counterStatusText += ", " + counters.overflow + " Over";
        interactionsStatus = (
          <Typography
            style={{ display: "inline-block", justifyContent: "center", alignItems: "center", verticalAlign: "middle" }}
          >
            <label>| &nbsp; </label>
            <Typography
              style={{
                display: "inline-block",
                justifyContent: "center",
                alignItems: "center",
                verticalAlign: "middle"
              }}
            >
              <label>{counterStatusText}</label>
              <LinearProgress variant="determinate" value={percent} color={linearColor} />
            </Typography>
          </Typography>
        );
      }
    }

    return (
      <Typography>
        {licenseInfo} {chatStatus} {interactionsStatus}
      </Typography>
    );
  };

  render() {
    return this.getLicenseInfo();
  }

  processLicenses(licenseData) {
    const licenses = licenseData.licenses.Items;
    const resources = licenseData.resources.Items;

    // Counters by subscription
    let counters = [];
    _.map(licenses, item => {
      _.map(item.counters, (counter, counter_code) => {
        counters.push({
          plan_code: item.plan_code,
          code: counter_code,
          counterLimit: counter.counterLimit,
          limit: counter.limit,
          counter: counter.counter
        });
      });
    });

    console.log("LicenseData", licenseData);

    const licenseSum = {};
    _.map(_.groupBy(counters, "code"), (objs, key) => {
      if (!licenseSum[key]) licenseSum[key] = {};
      _.map(_.groupBy(objs, "plan_code"), (objs2, key2) => {
        const sum1 = _.sumBy(objs2, "counterLimit");
        const sum2 = _.sumBy(objs2, "limit");
        const sum3 = _.sumBy(objs2, "counter");
        if (!licenseSum[key][key2]) licenseSum[key][key2] = { counterLimitSum: sum1, limitSum: sum2, counterSum: sum3 };
        else {
          licenseSum[key][key2].counterLimitSum += sum1;
          licenseSum[key][key2].limitSum += sum2;
          licenseSum[key][key2].counterSum += sum3;
        }
      });
    });

    // Create free license (if not created)
    if (!licenseSum.users) licenseSum.users = {};
    if (!licenseSum.users.starter) licenseSum.users.starter = { counterLimitSum: 25, limitSum: 25, counterSum: 0 };

    console.log("State Licenses:", licenseSum);
    this.setState({ licenses: licenseSum });

    // resources sum
    const resourcesSum = {};
    _.map(licenseSum, (codes, key) => {
      _.map(codes, (x, key2) => {
        if (!resourcesSum[key]) {
          resourcesSum[key] = { [key2]: { counterSum: 0 } };
        } else {
          resourcesSum[key][key2] = { counterSum: 0 };
        }
      });
    });

    // Load resources
    _.map(resources, resource => {
      console.log("Loading resource", resource.tenant, resource.user);
      _.map(resource.counters, (part1, code) => {
        _.map(part1, (counter, plan_code) => {
          console.log("Loading resource counter", code, plan_code, counter);
          if (!resourcesSum[code]) resourcesSum[code] = {};
          if (!resourcesSum[code][plan_code]) resourcesSum[code][plan_code] = { counterSum: counter.counter };
          else {
            resourcesSum[code][plan_code].counterSum += counter.counter;
          }
        });
      });
    });
    this.setState({ resourcesSum: resourcesSum });
    console.log("State Resources Sum:", resourcesSum);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.subscriptions.license) {
      this.processLicenses(nextProps.subscriptions.license.license);
    }
  }

  getTenantInteractionCounters() {
    const data = {
      method: "getTenantInteractionCounters",
      params: {}
    };
    return this.props.getTenantInteractionCounters(data);
  }

  getExternalChatbotStatus() {
    const data = {
      method: "hacConfiguredChatbot",
      params: {}
    };
    return this.props.getExternalChatbotStatus(data);
  }

  componentDidMount() {
    setTimeout(() => {
      this.getExternalChatbotStatus().then(result => {
        console.log("Chatbot status received:", result);
        this.setState({ chatbotStatus: result });
      });
    }, 1000);

    setTimeout(() => {
      this.getTenantInteractionCounters().then(result => {
        console.log("Interactions status received:", result);
        this.setState({ interactionCounters: result });
      });
    }, 1000);
  }
}

CountersInfo.propTypes = {
  getExternalChatbotStatus: PropTypes.func,
  getTenantInteractionCounters: PropTypes.func
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    subscriptions: state.subscriptions ? state.subscriptions : {}
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        getExternalChatbotStatus,
        getTenantInteractionCounters
      },
      dispatch
    ),
    dispatch
  };
}

CountersInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(CountersInfo);

export default withStyles(subscriptionCommon.styles)(CountersInfo);
